const pad = (n) => String(n).padStart(2, "0");

export const PATCHING_WINDOW_PRESETS = [
  { value: "lunch", label: "Lunch", startTime: "12:30", endTime: "13:00" },
  { value: "night", label: "Night", startTime: "20:00", endTime: "20:30" },
];

export function getPatchingWindowDatetimeLocal(dateLocal, preset = "night") {
  const patchingWindow = PATCHING_WINDOW_PRESETS.find(
    (option) => option.value === preset
  );
  return {
    startLocal: `${dateLocal}T${patchingWindow.startTime}`,
    endLocal: `${dateLocal}T${patchingWindow.endTime}`,
  };
}

/**
 * Default patching window: same calendar day, 20:00–20:30 (local).
 */
export function getDefaultPatchingDatetimeLocalToday() {
  const d = new Date();
  const y = d.getFullYear();
  const m = d.getMonth();
  const day = d.getDate();
  return getPatchingWindowDatetimeLocal(`${y}-${pad(m + 1)}-${pad(day)}`);
}

export function isoToDatetimeLocalValue(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function datetimeLocalToIso(localStr) {
  if (!localStr || !String(localStr).trim()) return null;
  const d = new Date(localStr);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
}
